import React, { useState } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import Button from 'components/form/Button';
import TextInput from 'components/form/TextInput';
import { Table } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { handleAddOnServicesData, showSuccess } from 'store/slices';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';

const ServicesDataForm = ({
  setIsServicesData,
  eventId,
  fetchAddOnServices,
  addOnServicesData,
}) => {
  const [loading, setLoading] = useState(false);
  const userData = getDataFromLocalStorage();

  const { user_type } = userData;
  const initialValues = {
    services: addOnServicesData?.services?.length
      ? addOnServicesData?.services?.map((service) => ({
          id: service.id || '',
          category: service.category || '',
          free_member: service.free_member ?? 0,
          premium_member: service.premium_member ?? 0,
        }))
      : [{ id: '', category: '', free_member: 0, premium_member: 0 }],
    visibility: {
      paper_submission_service:
        addOnServicesData?.paper_submission_service !== '0' ? true : false,
      plag_revision_service:
        addOnServicesData?.plag_revision_service !== '0' ? true : false,
      reviewer_revision_service:
        addOnServicesData?.reviewer_revision_service !== '0' ? true : false,
    },
  };

  const validationSchema = Yup.object().shape({
    services: Yup.array().of(
      Yup.object().shape({
        category: Yup.string().required('Category is Required'),
        free_member: Yup.number()
          .typeError('Must be a number')
          .required('Free Membership is Required'),
        premium_member: Yup.number()
          .typeError('Must be a number')
          .required('Premium Membership is Required'),
      })
    ),
  });

  const dispatch = useDispatch();
  const handleSave = async (values, { setSubmitting }) => {
    setLoading(true);

    const payload = {
      service_data: JSON.stringify(values?.services) || [],
      event_id: eventId || '',
      paper_submission_service: values?.visibility?.paper_submission_service
        ? 1
        : 0,
      plag_revision_service: values?.visibility?.plag_revision_service ? 1 : 0,
      reviewer_revision_service: values?.visibility?.reviewer_revision_service
        ? 1
        : 0,
    };

    const response = await dispatch(
      handleAddOnServicesData(objectToFormData(payload))
    );

    if (response?.status === 200) {
      fetchAddOnServices();
      dispatch(showSuccess(response?.message));
      setIsServicesData(false);
    }
    setLoading(false);
    setSubmitting(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        handleChange,
        setFieldValue,
        dirty,
        isSubmitting,
      }) => (
        <Form>
          <FieldArray name="services">
            {({ push, remove }) => (
              <>
                {values.services.map((service, index) => (
                  <div key={index} className="row g-3 mb-3">
                    {/* Category Field */}
                    <div className="col-md-4 col-12">
                      <TextInput
                        label="Category"
                        placeholder="Category"
                        id={`services.${index}.category`}
                        value={values.services[index].category}
                        error={errors.services?.[index]?.category}
                        // onChange={(e) => {
                        //   handleChange(e);
                        //   if (addOnServicesData?.services?.[index]) {
                        //     const isUpdated =
                        //       e.target.value !==
                        //       addOnServicesData?.services[index].category;
                        //     setFieldValue(
                        //       `services.${index}.is_updated_category`,
                        //       isUpdated
                        //     );
                        //   }

                        // }}
                        onChange={(e) => {
                          handleChange(e);
                          if (user_type === '6') {
                            if (addOnServicesData?.services?.[index]) {
                              const isUpdated =
                                e.target.value !==
                                addOnServicesData.services[index].category;
                              setFieldValue(
                                `services.${index}.is_updated_category`,
                                isUpdated
                              );
                            } else {
                              // If it's a new entry, set `is_updated_category` to true
                              setFieldValue(
                                `services.${index}.is_updated_category`,
                                true
                              );
                            }
                          }
                        }}
                      />
                    </div>

                    {/* Free Membership Field */}
                    <div className="col-md-3 col-12">
                      <TextInput
                        label="Free Membership"
                        placeholder="Free Membership"
                        id={`services.${index}.free_member`}
                        value={values.services?.[index]?.free_member}
                        onChange={(e) => {
                          handleChange(e);
                          // if (addOnServicesData?.services?.[index]) {
                          //   const isUpdated =
                          //     Number(e.target.value) !==
                          //     Number(
                          //       addOnServicesData?.services[index]
                          //         .free_member
                          //     );
                          //   setFieldValue(
                          //     `services.${index}.is_updated_free_membership`,
                          //     isUpdated
                          //   );
                          // }

                          if (user_type === '6') {
                            if (addOnServicesData?.services?.[index]) {
                              const isUpdated =
                                Number(e.target.value) !==
                                Number(
                                  addOnServicesData?.services[index].free_member
                                );
                              setFieldValue(
                                `services.${index}.is_updated_free_membership`,
                                isUpdated
                              );
                            } else {
                              // If it's a new entry, set `is_updated_category` to true
                              setFieldValue(
                                `services.${index}.is_updated_free_membership`,
                                true
                              );
                            }
                          }
                        }}
                        error={errors.services?.[index]?.free_member}
                      />
                    </div>

                    {/* Premium Membership Field */}
                    <div className="col-md-3 col-12">
                      <TextInput
                        label="Premium Membership"
                        placeholder="Premium Membership"
                        id={`services.${index}.premium_member`}
                        value={values.services?.[index]?.premium_member}
                        // onChange={handleChange}
                        onChange={(e) => {
                          handleChange(e);
                          // if (addOnServicesData?.services?.[index]) {
                          //   const isUpdated =
                          //     Number(e.target.value) !==
                          //     Number(
                          //       addOnServicesData?.services[index]
                          //         .premium_member
                          //     );
                          //   setFieldValue(
                          //     `services.${index}.is_updated_premium_membership`,
                          //     isUpdated
                          //   );
                          // }

                          if (user_type === '6') {
                            if (addOnServicesData?.services?.[index]) {
                              const isUpdated =
                                Number(e.target.value) !==
                                Number(
                                  addOnServicesData?.services[index]
                                    .premium_member
                                );
                              setFieldValue(
                                `services.${index}.is_updated_premium_membership`,
                                isUpdated
                              );
                            } else {
                              // If it's a new entry, set `is_updated_category` to true
                              setFieldValue(
                                `services.${index}.is_updated_premium_membership`,
                                true
                              );
                            }
                          }
                        }}
                        error={errors.services?.[index]?.premium_member}
                      />
                    </div>

                    {/* Remove Button */}
                    <div className="col-md-2 d-flex align-items-center col-12">
                      {values.services.length > 0 && (
                        <Button
                          icon={<i className="bi bi-trash fs-5" />}
                          btnStyle="primary-outline"
                          className="h-35 text-14-500 text-nowrap w-auto px-3"
                          onClick={() => remove(index)}
                        />
                      )}
                    </div>
                  </div>
                ))}

                {/* Add Services Button - Left Aligned */}
                <div className="mt-3">
                  <Button
                    text="+ Add Services"
                    btnStyle="primary-outline"
                    className="h-35 text-14-500 text-nowrap w-auto px-3"
                    onClick={() =>
                      push({
                        category: '',
                        free_member: '',
                        premium_member: '',
                      })
                    }
                  />
                </div>
              </>
            )}
          </FieldArray>

          {/* Visibility Configuration Table */}
          <div
            className="cmt-20"
            style={{ maxWidth: '438px', overflowX: 'auto' }}
          >
            <Table bordered className="w-100 ">
              <thead>
                <tr>
                  <th className="text-center text-14-500-18 bg-E9EE">
                    Visibility Configuration
                  </th>
                  <th className="text-center text-14-500-18 bg-E9EE">
                    Visibility
                  </th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(values.visibility).map((key, index) => (
                  <tr key={index}>
                    <td className="text-center text-14-400-18">
                      {key === 'paper_submission_service'
                        ? 'Paper Submission'
                        : key === 'plag_revision_service'
                        ? 'Plag Revision / Rejection'
                        : 'Reviewer Revision / Rejection'}
                    </td>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        name={`visibility.${key}`}
                        checked={values.visibility[key]}
                        onChange={(e) =>
                          setFieldValue(`visibility.${key}`, e.target.checked)
                        }
                      />
                      {/* <td className="d-flex justify-content-center align-items-center cmt-5">
                      <CheckBox
                        type="PRIMARY-ACTIVE"
                        isChecked={values.visibility[key]}
                        onClick={() =>
                          setFieldValue(
                            `visibility.${key}`,
                            !values.visibility[key]
                          )
                        }
                      />
                    </td> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Buttons */}
          <div className="mt-3 d-flex gap-2 cmt-20">
            <Button
              btnStyle="primary-dark"
              text="Submit"
              className="h-35 text-14-500 text-nowrap w-auto px-3"
              type="submit"
              btnLoading={loading}
              disabled={loading || isSubmitting || !dirty}
            />
            <Button
              btnStyle="light-outline"
              text="Cancel"
              className="h-35 text-14-500 text-nowrap w-auto px-3"
              type="button"
              disabled={loading}
              onClick={() => setIsServicesData(false)}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ServicesDataForm;
